import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { faBell } from '@soundxyz/font-awesome/sharp-solid-svg-icons/index.mjs';
import { Indicator } from '@components/Notifications/shared';
import { useUserNotificationStatus } from '@components/Notifications/useUserNotificationStatus';
import { useUserNotifications } from '@components/Notifications/useUserNotifications';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { NAV_LINKS } from '@utils/constants';

export const NotificationBell = ({
  variant,
}: {
  variant: React.ComponentProps<typeof IconButton>['variant'];
}) => {
  const { hasUnreadNotifications, markNotificationsAsRead, isMarkingNotificationsAsRead } =
    useUserNotificationStatus();
  const { refetch } = useUserNotifications();

  return (
    <AccessibleLink
      pathnameUri={NAV_LINKS.NotificationPage}
      onClick={() => {
        markNotificationsAsRead();
        refetch();
      }}
      disabled={isMarkingNotificationsAsRead}
    >
      <div className="relative flex h-fit w-fit rounded-full">
        {hasUnreadNotifications && <Indicator className="right-[7px] top-[7px]" />}
        <IconButton
          variant={variant}
          size={41}
          icon={<FontAwesomeIcon icon={faBell} />}
          iconSize={19}
          className={twMerge(variant === 'primary' && '!text-base900 md:!text-base500')}
        />
      </div>
    </AccessibleLink>
  );
};
